const house_sec1_part3Object = (payload) => {
  return {
    type: "housesec1part3object",
    payload,
  };
};

export default house_sec1_part3Object;
